import { render } from "./DefaultLayout.vue?vue&type=template&id=770c32ae&scoped=true&ts=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts"

import "./DefaultLayout.vue?vue&type=style&index=0&id=770c32ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770c32ae"]])

export default __exports__